/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExamenEntreeFceFichierGridDto
 */
export interface ExamenEntreeFceFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFceFichierGridDto
     */
    idexamenEntreeFceFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFceFichierGridDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof ExamenEntreeFceFichierGridDto
     */
    typeAcquisFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFceFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExamenEntreeFceFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFceFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExamenEntreeFceFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ExamenEntreeFceFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the ExamenEntreeFceFichierGridDto interface.
 */
export function instanceOfExamenEntreeFceFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExamenEntreeFceFichierGridDtoFromJSON(json: any): ExamenEntreeFceFichierGridDto {
    return ExamenEntreeFceFichierGridDtoFromJSONTyped(json, false);
}

export function ExamenEntreeFceFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamenEntreeFceFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idexamenEntreeFceFichier': !exists(json, 'idexamenEntreeFceFichier') ? undefined : json['idexamenEntreeFceFichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'typeAcquisFichier': !exists(json, 'typeAcquisFichier') ? undefined : json['typeAcquisFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function ExamenEntreeFceFichierGridDtoToJSON(value?: ExamenEntreeFceFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idexamenEntreeFceFichier': value.idexamenEntreeFceFichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'typeAcquisFichier': value.typeAcquisFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

